(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quantum-confidence"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mobile = window.matchMedia('(max-width: 600px)');
  const configure = () => document.querySelectorAll('details.qt-confidence__card').forEach(card => {
    card.open = !mobile.matches;
    card.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
  });
  configure();
  mobile.addEventListener('change', configure);
  document.addEventListener('shopify:section:load', configure);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quantum-home-b"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('qb-home-gallery')) {
  customElements.define('qb-home-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('.qb-home__gallery-track');
      const controls = this.querySelector('.qb-home__gallery-controls');
      if (!track) return;
      let gesture = null;
      let suppressClickUntil = 0;
      track.addEventListener('pointerdown', event => {
        suppressClickUntil = 0;
        if (!event.isPrimary || event.button !== 0 || !event.target.closest('.qb-home__gallery-link')) {
          gesture = null;
          return;
        }
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, scroll: track.scrollLeft, moved: false };
      }, { ...options, passive: true });
      const noteMovement = event => {
        if (!gesture || event.pointerId !== gesture.id) return;
        if (Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 10 || Math.abs(track.scrollLeft - gesture.scroll) > 8) gesture.moved = true;
      };
      document.addEventListener('pointermove', noteMovement, { ...options, passive: true });
      const endGesture = event => {
        if (!gesture || event.pointerId !== gesture.id) return;
        noteMovement(event);
        if (gesture.moved || event.type === 'pointercancel') suppressClickUntil = performance.now() + 800;
        gesture = null;
      };
      document.addEventListener('pointerup', endGesture, { ...options, passive: true });
      document.addEventListener('pointercancel', endGesture, { ...options, passive: true });
      track.addEventListener('click', event => {
        if (!event.target.closest('.qb-home__gallery-link') || event.detail === 0 || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (performance.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
          suppressClickUntil = 0;
        }
      }, { ...options, capture: true });
      track.addEventListener('dragstart', event => {
        if (event.target.closest('.qb-home__gallery-link')) event.preventDefault();
      }, options);
      if (!controls) return;
      const slides = Array.from(track.children);
      const dots = Array.from(controls.querySelectorAll('[data-slide]'));
      const arrows = Array.from(controls.querySelectorAll('[data-step]'));
      let current = 0;
      let frame = 0;
      const sync = () => {
        frame = 0;
        current = Math.max(0, Math.min(slides.length - 1, Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1))));
        dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
        arrows.forEach(button => button.disabled = Number(button.dataset.step) < 0 ? current === 0 : current === slides.length - 1);
      };
      const go = index => {
        const target = Math.max(0, Math.min(slides.length - 1, index));
        const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
        track.scrollTo({ left: direction * target * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      controls.hidden = false;
      controls.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-slide')) go(Number(button.dataset.slide));
        else go(current + Number(button.dataset.step));
      }, options);
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') go(0);
        else if (event.key === 'End') go(slides.length - 1);
        else go(current + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      track.addEventListener('scroll', () => {
        if (!frame) frame = requestAnimationFrame(sync);
      }, { ...options, passive: true });
      this.controller.signal.addEventListener('abort', () => cancelAnimationFrame(frame), { once: true });
      this.resizeObserver = new ResizeObserver(sync);
      this.resizeObserver.observe(track);
      sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quantum-set-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('quantum-set-finder')) {
  customElements.define('quantum-set-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.result = this.querySelector('.quantum-finder__result');
      this.form.hidden = false;
      this.querySelector('.quantum-finder__fallback').hidden = true;
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (!this.form.reportValidity()) return;
        const answers = new FormData(this.form);
        const use = answers.get('use');
        const group = answers.get('group');
        const experience = answers.get('experience');
        const selected = group === 'large' || use === 'sound' ? '7' : group === 'medium' ? '4' : '3';
        this.querySelectorAll('[data-finder-set]').forEach(card => {
          card.hidden = card.dataset.finderSet !== selected;
          card.querySelectorAll('[data-finder-level]').forEach(tip => { tip.hidden = tip.dataset.finderLevel !== experience; });
          if (card.dataset.finderSet === '7') card.querySelectorAll('[data-finder-reason]').forEach(reason => { reason.hidden = reason.dataset.finderReason !== (group === 'large' ? 'large' : 'sound'); });
        });
        this.result.hidden = false;
        this.querySelector('[data-finder-set="' + selected + '"] h3').focus({preventScroll:true});
        this.result.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      });
      this.form.addEventListener('change', () => { this.result.hidden = true; });
      this.querySelector('[data-finder-reset]').addEventListener('click', () => {
        this.form.reset();
        this.result.hidden = true;
        this.form.querySelector('input').focus();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
